import { Link } from "react-router-dom";

const Logo = ({ to = "/", ...rest }) => (
  <Link to={to}>
    <img alt="Logo" src="/static/logo.png" {...rest} />
  </Link>
);

export default Logo;
